import React from 'react'
import { Heading } from '@myxplor/ui'

const NoGovRegistrations = () => <Heading small>No Government Registrations</Heading>

export default NoGovRegistrations



// WEBPACK FOOTER //
// ./src/gov-registrations/views/empty.jsx